/** Set by hand-managed flags, not billing data, so copy can't cite amounts or dates. */
export enum BillingDelinquencyTier {
	OVERDUE = 'OVERDUE',
	SUSPENDED = 'SUSPENDED',
	LOCKED = 'LOCKED',
}

export type ConfiningBillingDelinquencyTier =
	| BillingDelinquencyTier.SUSPENDED
	| BillingDelinquencyTier.LOCKED;

export const DELINQUENCY_BANNER_COPY = {
	label: 'Suspension Risk:',
	before: 'Outstanding balance is past due. Your Payout account(s) are at risk of being paused. Please update your payment method on the',
	action: 'Billing page',
	after: 'to avoid losing Business Manager access.',
};

export const DELINQUENCY_MODAL_ACTION_TEXT = 'Update Payment Method(s)';

export const DELINQUENCY_LOCKED_NAV_TOOLTIP =
	'Unavailable until your balance is paid — update your payment method to restore access.';

/** Eyebrows stay title case; CSS uppercases them so screen readers don't shout. */
export const DELINQUENCY_MODAL_COPY: Record<
	ConfiningBillingDelinquencyTier,
	{ eyebrow: string; title: string; body: string }
> = {
	[BillingDelinquencyTier.SUSPENDED]: {
		eyebrow: 'Account Suspended',
		title: 'Your Business Manager access has been turned off due to non-payment.',
		body: 'To restore access to your account, please update your payment method as soon as possible.',
	},
	[BillingDelinquencyTier.LOCKED]: {
		eyebrow: 'Account Locked',
		title: 'Your Business Manager and Employee App access has been turned off due to non-payment.',
		body: 'Payout account(s) and the ability to take customer payments have been disabled. To restore access to your account and services, please update your payment method.',
	},
};

export const DELINQUENCY_BLOCKED_COPY = {
	title: DELINQUENCY_MODAL_COPY[BillingDelinquencyTier.SUSPENDED].title,
	body: 'Only a Business Owner can update the payment method. Please contact them to restore access.',
	action: 'Logout',
};
